import { HttpClient, type HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { Api } from 'src/app/core/api/Api';

export interface CockpitLogin {
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class CockpitService {
  constructor(
    private http: HttpClient,
    private appService: AppService,
  ) {}

  loginKws(): Observable<CockpitLogin> {
    return this.http.get<CockpitLogin>(Api.KwsCockpitLogin);
  }

  loginBestandsCockpit(): Observable<CockpitLogin> {
    return this.http.get<CockpitLogin>(Api.BestandskundenCockpitLogin);
  }

  openBestandskundenCockpit() {
    this.loginBestandsCockpit().subscribe({
      next: ({ url }) => {
        window.open(url, '_blank');
      },
      error: (error: HttpErrorResponse) => {
        this.appService.error(
          error.status === 404
            ? 'kws.actions.cockpit.notFound'
            : 'kws.actions.cockpit.error',
        );
      },
    });
  }

  openKwsCockpit() {
    this.loginKws().subscribe({
      next: ({ url }) => {
        window.open(url, '_blank');
      },
      error: (error: HttpErrorResponse) => {
        this.appService.error(
          error.status === 404
            ? 'kws.actions.cockpit.notFound'
            : 'kws.actions.cockpit.error',
        );
      },
    });
  }
}
